export enum BagVariant {
  FRUITS = 'fruits',
  BREAD = 'bread',
}